export const ShortTermStatus = Object.freeze({
  CANCELLED: -1,
  CLIENT_ERROR: -10,
  CLIENT_CONCERN_AGENCY_TOOK_TOO_LONG: -11,
  UNABLE_TO_FILL: -12,
  ANZUK_ERROR: -13,
  CANDIDATE_ILLNESS: -14,
  AGENCY_MOVED_CLIENT: -15,
  TRAINING: -16,
  OTHER: -17,
  CLIENT_CANCELLED: -18,
  CANDIDATE_CANCELLED: -19,
  CANDIDATE_AND_CLIENT_STATED_BOOKING_DID_NOT_HAPPEN: -20,
  PARTIAL_EXPORT_REVIEW_IN_BULLHORN: -41,
  DELETED_FROM_GROUP_BOOKING: -50,
  CANDIDATE_SICK_NO_COVER_REQUIRED: -99,
  LAPSED: -100,
  FINANCE_CANCELLED: -101,
  REFUNDED: -1000,
  ACTIVE_LAPSED: 13,
  ACTIVE_WITHOLD_PAY: 14,
  BOOKING_NOT_APPROVED: 70,
  ECH_BOOKING_NOT_APPROVED: 80,
  ECH_READY_FOR_INVOICING: 95,
  FRIDAY_INVOICE: 99,
  TENTATIVE: 105,
  CLIENT_SUBMITTED_TIMESHEET_NO_CHANGES: 111,
  CLIENT_SUBMITTED_TIMESHEET_MODIFIED: 112,
  CLIENT_SUBMITTED_TIMESHEET_DID_NOT_HAPPEN: 113,
  CANDIDATE_SUBMITTED_TIMESHEET_NO_CHANGES: 114,
  CANDIDATE_SUBMITTED_TIMESHEET_MODIFIED: 115,
  CANDIDATE_SUBMITTED_TIMESHEET_DID_NOT_HAPPEN: 116,
  TIMESHEET_DISPUTE_OR_MISMATCH: 117,
  EXPORTED_TO_BULLHORN_NZ: 175,
  BULK_SUBMITABLE: [70, 80, 111, 114],

  getMissingSingleTimesheet() {
    return [
      ShortTermStatus.CLIENT_SUBMITTED_TIMESHEET_NO_CHANGES,
      ShortTermStatus.CLIENT_SUBMITTED_TIMESHEET_MODIFIED,
      ShortTermStatus.CLIENT_SUBMITTED_TIMESHEET_DID_NOT_HAPPEN,
      ShortTermStatus.CANDIDATE_SUBMITTED_TIMESHEET_NO_CHANGES,
      ShortTermStatus.CANDIDATE_SUBMITTED_TIMESHEET_MODIFIED,
      ShortTermStatus.CANDIDATE_SUBMITTED_TIMESHEET_DID_NOT_HAPPEN,
    ]
  },

  getAllMissingTimesheets() {
    return [
      ...ShortTermStatus.getMissingSingleTimesheet(),
      ShortTermStatus.ECH_BOOKING_NOT_APPROVED,
      ShortTermStatus.BOOKING_NOT_APPROVED,
    ]
  },

  getConflictingTimesheetStatuses() {
    return [ShortTermStatus.TIMESHEET_DISPUTE_OR_MISMATCH]
  },

  getCandidateSubmittedStatuses() {
    return [
      ShortTermStatus.CANDIDATE_SUBMITTED_TIMESHEET_NO_CHANGES,
      ShortTermStatus.CANDIDATE_SUBMITTED_TIMESHEET_MODIFIED,
      ShortTermStatus.CANDIDATE_SUBMITTED_TIMESHEET_DID_NOT_HAPPEN,
      ShortTermStatus.TIMESHEET_DISPUTE_OR_MISMATCH,
    ]
  },

  getClientSubmittedStatuses() {
    return [
      ShortTermStatus.CLIENT_SUBMITTED_TIMESHEET_NO_CHANGES,
      ShortTermStatus.CLIENT_SUBMITTED_TIMESHEET_MODIFIED,
      ShortTermStatus.CLIENT_SUBMITTED_TIMESHEET_DID_NOT_HAPPEN,
      ShortTermStatus.TIMESHEET_DISPUTE_OR_MISMATCH,
    ]
  },

  friendlyNameFor(status) {
    switch (status) {
      case ShortTermStatus.CANDIDATE_SUBMITTED_TIMESHEET_NO_CHANGES:
        return 'Client missing - no changes'
      case ShortTermStatus.CANDIDATE_SUBMITTED_TIMESHEET_MODIFIED:
        return 'Client missing - modifications'
      case ShortTermStatus.CANDIDATE_SUBMITTED_TIMESHEET_DID_NOT_HAPPEN:
        return 'Client missing - cancelled'
      case ShortTermStatus.CLIENT_SUBMITTED_TIMESHEET_NO_CHANGES:
        return 'Candidate missing - no changes'
      case ShortTermStatus.CLIENT_SUBMITTED_TIMESHEET_MODIFIED:
        return 'Candidate missing - modifications'
      case ShortTermStatus.CLIENT_SUBMITTED_TIMESHEET_DID_NOT_HAPPEN:
        return 'Candidate missing - cancelled'
      case ShortTermStatus.TIMESHEET_DISPUTE_OR_MISMATCH:
        return 'Conflicting timesheets'
    }
  },
})
